import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ICON, ICON_STYLE } from '@core/util/icon';
import { MatterStatus } from '@models/matter';

@Component({
	selector: 'app-matter-status-indicator',
	templateUrl: './matter-status-indicator.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class MatterStatusIndicatorComponent {
	ICON = ICON;
	ICON_STYLE = ICON_STYLE;

	MATTER_STATUS = MatterStatus;

	@Input() status: MatterStatus;
}
